import config from "@/config/config";
import { getDecodedEvent, readContract, toBool, writeContractAndWait } from "../viem";
import MafiaOCExecutionAbi from "../../abis/MafiaOCExecution.json";
import { parseLobbyFinishEvent } from "../oc";

export const startLobby = async (lobbyId: number, account: string) => {
  const tx = await writeContractAndWait({
    address: config.ocExecutionAddress,
    abi: MafiaOCExecutionAbi,
    functionName: "startLobby",
    args: [lobbyId],
    account,
  });
  return tx;
};

export const finishLobby = async (lobbyId: number, account: string) => {
  const tx = await writeContractAndWait({
    address: config.ocExecutionAddress,
    abi: MafiaOCExecutionAbi,
    functionName: "finishLobby",
    args: [lobbyId],
    account,
  });

  const event = getDecodedEvent(tx, MafiaOCExecutionAbi, "LobbyFinished");
  const lobbyFinishEvent = event ? parseLobbyFinishEvent(event) : undefined;
  return {
    blockNumber: Number(tx.blockNumber),
    txHash: tx.transactionHash,
    lobbyFinishEvent,
  };
};

export const claimLobbyReward = async (lobbyId: number, account: string) => {
  const tx = await writeContractAndWait({
    address: config.ocExecutionAddress,
    abi: MafiaOCExecutionAbi,
    functionName: "claimLobbyReward",
    args: [lobbyId],
    account,
  });
  return tx;
};

export const getLobbyNonceStatus = async (lobbyId: number) => {
  const isReadyToFinish = await readContract({
    address: config.ocExecutionAddress,
    abi: MafiaOCExecutionAbi,
    functionName: "getLobbyNonceStatus",
    args: [lobbyId],
    useWallet: true,
  });
  return toBool(isReadyToFinish);
};
